import { Link } from 'react-router-dom'
import { Clock, Smartphone, FileSpreadsheet, Route } from 'lucide-react'

import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { useAuth } from '@/hooks/use-auth'
import { buildAppHref } from '@/lib/auth'

const features = [
  { to: '/tt', icon: Clock, title: 'Travel Time', desc: 'Monitor travel times across multiple road links in real-time' },
  { to: '/devices', icon: Smartphone, title: 'Devices', desc: 'Check status of monitoring nodes' },
  { to: '/reports', icon: FileSpreadsheet, title: 'Reports', desc: 'Generate Excel reports for daily and weekly analysis' },
]

export function HomePage() {
  const auth = useAuth()

  return (
    <>
      <div className="py-16 px-8 text-center text-white">
        <h1 className="text-5xl font-bold mb-4" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>
          <Route className="inline h-10 w-10 mr-2" />
          BT Travel Time Monitoring
        </h1>
        {auth?.mode === 'admin' ? (
          <p className="text-sm text-white/85">
            Admin session active{auth.projectCode ? ` for ${auth.projectCode}` : ''}.
          </p>
        ) : null}
      </div>

      <div className="mx-auto max-w-[1200px] px-8">
        <Card className="bg-card/95 backdrop-blur-sm">
          <div className="p-8">
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {features.map(({ to, icon: Icon, title, desc }) => (
                <Link key={to} to={buildAppHref(to, auth)} className="no-underline">
                  <Card className="h-full text-center transition-all hover:-translate-y-1 hover:shadow-lg cursor-pointer">
                    <CardHeader className="items-center">
                      <Icon className="mb-2 h-12 w-12 text-primary" />
                      <CardTitle>{title}</CardTitle>
                      <CardDescription>{desc}</CardDescription>
                    </CardHeader>
                  </Card>
                </Link>
              ))}
            </div>
          </div>
        </Card>
      </div>
    </>
  )
}
